import { DataStoreType } from "../../../stores/dataStore";
import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function getTableData(): Promise<DataStoreType["data"] | "INVALID_SESSION" | null> {
    try {
        const { data: { user } } = await supabase.auth.getUser();

        if (!user) {
            return "INVALID_SESSION";
        }

        const userId = user.id;

        const [folderResult, noteResult, deletedResult] = await Promise.all([
            supabase.from("folders").select().eq("user_id", userId),
            supabase.from("notes").select().eq("user_id", userId),
            supabase.from("deleted").select().eq("user_id", userId)
        ]);

        if (folderResult.error) throw folderResult.error;
        if (noteResult.error) throw noteResult.error;
        if (deletedResult.error) throw deletedResult.error;

        const foldersData = folderResult.data || [];
        const notesData = noteResult.data || [];
        const deletedData = deletedResult.data || [];

        const folders = foldersData.reduce((acc: { [id: string]: any }, folder: any) => {
            acc[folder.id] = {
                id: folder.id,
                name: folder.name,
                color: folder.color !== null ? folder.color : 0,
                createdAt: folder.created_at || new Date().toISOString(),
                updatedAt: folder.updated_at || new Date().toISOString(),
            };
            return acc;
        }, {});

        const notes = notesData.reduce((acc: { [id: string]: any }, note: any) => {
            acc[note.id] = {
                id: note.id,
                title: note.title,
                folderID: note.folder_id || undefined,
                tagIDs: note.tag_ids || [],
                createdAt: note.created_at || new Date().toISOString(),
                updatedAt: note.updated_at || new Date().toISOString(),
            };
            return acc;
        }, {});

        const deleted = {
            notes: deletedData[0]?.notes || [],
            folders: deletedData[0]?.folders || [],
            tags: deletedData[0]?.tags || [],
        };

        return {
            notes,
            folders,
            tags: {},
            deleted
        };
    } catch (error) {
        console.error("Error fetching table data:", error);
        return null;
    }
}
